'use strict';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/toPromise';
import {getTrackLocation} from '../../settings/reducers/state';
import * as trackLocationActions from '../../settings/actions/trackLocationActions';

const CACHE_KEY = 'getCurrentPosition';
const REGISTER_PAYLOAD = {
  key: CACHE_KEY,
  resumeOnLoad: false,
  once: true,
};

DeviceServices.$inject = [
  'DeviceServicesImpl',
  '$ngRedux',
];

export function DeviceServices(
  DeviceServicesImpl,
  $ngRedux,
) {
  let _cachedRequest$ = null;

  /**
   * Methods:
   *
   * supportsCamera
   * returns boolean
   */
  return {
    ...DeviceServicesImpl,
    getCurrentPosition,
    _cachedRequest$: null,
  };

  /**
   * @return {Promise<UpdatePositionPayload>}
   */
  function getCurrentPosition() {
    const state = getTrackLocation($ngRedux.getState());

    if (state.lastPositionPayload !== null) {
      return Promise.resolve(state.lastPositionPayload);
      // otherwise, wait for next position using the request method below
    }

    // Only allow 1 request in-flight at a time.
    if (_cachedRequest$ === null) {

      // delay 1 tick
      setTimeout(() => $ngRedux.dispatch(trackLocationActions.registerTracking(REGISTER_PAYLOAD)), 0);

      _cachedRequest$ = $ngRedux.state$
        .map(rootState => getTrackLocation(rootState).lastPositionPayload)
        .filter(payload => payload !== null)
        .timeout(35000) // timeout after 35 seconds
        .take(1)
        .toPromise()
        .finally(() => {
          // clear the cached
          _cachedRequest$ = null;
          $ngRedux.dispatch(trackLocationActions.deregisterTracking(REGISTER_PAYLOAD));
        });
    }

    return _cachedRequest$;
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/device-services/DeviceServices.js